export default class Collection {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      themeId: null,
      listPosition: null,
      useTextVersion: false,
      translations: {
        de: {
          name: null
        },
        en: {
          name: null
        }
      },
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  setSave(data) {
    this.set(data)
    return this.save()
  }

  save() {
    return this.store.dispatch('collections/update', this)
  }

  getJSON() {
    return {
      id: this.id,
      themeId: this.themeId,
      translations: this.translations,
      listPosition: this.listPosition,
      useTextVersion: this.useTextVersion,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/collection/model.js